import React, { useState } from "react";
import FixedSampleList from "./FixedSampleList";
import ReactModal from "react-modal";
import Button from "../Button";

const customStyles = {
  overlay: {
    zIndex: 999999999,
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 10,
    borderColor: "#",
    maxHeight: "90vh",
    minWidth: "60vw",
    maxWidth: "90vw",
    overflowY: "scroll",
  },
};

export default function ModalFixedSampleList({ sample_ids }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  if (!show) {
    return (
      <Button
        tiny
        title={"Show " + sample_ids.length + " Samples"}
        icon="fa-eye"
        onClick={() => setShow(true)}
      />
    );
  }

  return (
    <ReactModal
      isOpen={show}
      ariaHideApp={false}
      onRequestClose={handleClose}
      style={customStyles}
    >
      <Button title="Close" tiny icon="fa-times" onClick={handleClose} />
      <FixedSampleList sampleIds={sample_ids} clientView={false} showAttributes={false} />
    </ReactModal>
  );
}
